import { Component, EventEmitter, Input, Output, Optional, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-copy-confirmation',
    styleUrls: ['./copy-confirmation.component.scss'],
    templateUrl: './copy-confirmation.component.html',
})
export class CopyConfirmationComponent {
    // For AppDialogWrapperService pattern
    @Output() dialogClosed = new EventEmitter<any>();
    @Output() cancelDialog = new EventEmitter<void>();

    @Input() data: any;
    
    // For backwards compatibility
    @Optional() public dialogRef?: any;
    @Optional() public closeConfirmationDialog?: any;

    constructor(
        public router: Router,
        @Optional() @Inject(MatDialogRef) dialogRef?: MatDialogRef<any>,
        @Optional() @Inject('CLOSE_CONFIRMATION_DIALOG') closeConfirmationDialog?: any,
        @Optional() @Inject(MAT_DIALOG_DATA) data?: any
    ) {
        // Backwards compatibility
        if (dialogRef) {
            this.dialogRef = dialogRef;
            dialogRef.disableClose = true;
        }
        if (closeConfirmationDialog) {
            this.closeConfirmationDialog = closeConfirmationDialog;
        }
        if (data) {
            this.data = data;
        }
    }

    public onCancelClick(): void {
        if (this.dialogRef) {
            this.dialogRef.close();
        } else {
            this.cancelDialog.emit();
        }
    }

    public onCopyClick(): void {
        if (this.dialogRef) {
            this.dialogRef.close(this.data);
        } else {
            this.dialogClosed.emit(this.data);
        }
    }
}
